<template>
  <div class="row mb-5">
    <div class="col-12">
      <div
        class="border rounded"
        :class="theme == 'light' ? 'bg-white' : 'border-info '"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-5">
              <h4 class="card-title mb-4">
                {{ $t("dashboards.report-statistics") }}
              </h4>
            </div>
            <div class="col-4">
              <div v-if="dailyReportInterval == 'date-range'">
                <div class="row">
                  <div class="col-5 px-1">
                    <input
                      class="form-control"
                      type="date"
                      id="class"
                      v-model="start_range"
                    />
                  </div>
                  <div class="col-5 px-1">
                    <input
                      class="form-control"
                      type="date"
                      id="class"
                      v-model="end_range"
                    />
                  </div>
                  <div class="col-2">
                    <b-button
                      class="btn btn-block btn-success text-white"
                      @click="getDailyReports()"
                    >
                      <span class="text-white">
                        {{ $t("dashboards.apply") }}</span
                      >
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="d-flex">
                <div class="d-flex">
                  <b-button
                    :variant="
                      charttype == 'line' ? 'primary' : 'outline-primary'
                    "
                    size="sm"
                    class="mr-2"
                    title="Line Chart"
                    @click="changeType('line')"
                  >
                    <i class="bx bxs-chart font-size-24 align-middle"></i>
                  </b-button>
                  <b-button
                    :variant="
                      charttype == 'bar' ? 'primary' : 'outline-primary'
                    "
                    size="sm"
                    class="mr-2"
                    title="Bar Chart"
                    @click="changeType('bar')"
                  >
                    <i
                      class="bx bxs-bar-chart-square font-size-24 align-middle"
                    ></i>
                  </b-button>
                </div>
                <select
                  class="form-control"
                  id="exampleFormControlSelect1"
                  v-model="dailyReportInterval"
                  @change="getDailyReports"
                >
                  <option value="7d">{{ $t("malware.last-7") }}</option>
                  <option value="30d">{{ $t("malware.last-30") }}</option>
                  <option value="3m">{{ $t("malware.last-90") }}</option>
                  <option value="date-range">
                    {{ $t("dashboards.date-range") }}
                  </option>

                  <!-- <option value="1y">1 {{ $t("dashboards.year") }}</option> -->
                </select>
              </div>
            </div>
          </div>
          <div v-if="loading.reportstatistic">
            <div class="text-center py-4 my-5">
              <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
              <span class="font-size-16"> Loading ... </span>
            </div>
          </div>
          <div v-if="!loading.reportstatistic">
            <!-- Dashed Line Chart -->
            <apexchart
              class="apex-charts"
              height="380"
              :type="charttype"
              dir="ltr"
              :series="reportStatistics.series"
              :options="{
                legend: {
                  show: true,
                  showForSingleSeries: false,
                  showForNullSeries: true,
                  showForZeroSeries: true,
                  position: 'bottom',
                  horizontalAlign: 'center',
                  floating: false,
                  fontSize: '14px',
                  fontFamily: 'Helvetica, Arial',
                  fontWeight: 400,
                  formatter: undefined,
                  inverseOrder: false,
                  width: undefined,
                  height: undefined,
                  tooltipHoverFormatter: undefined,
                  customLegendItems: [],
                  offsetX: 0,
                  offsetY: 0,
                  labels: {
                    colors: '#fff',
                    useSeriesColors: false,
                  },
                  markers: {
                    width: 12,
                    height: 12,
                    strokeWidth: 0,
                    strokeColor: '#fff',
                    fillColors: undefined,
                    radius: 12,
                    customHTML: undefined,
                    onClick: undefined,
                    offsetX: 0,
                    offsetY: 0,
                  },
                  itemMargin: {
                    horizontal: 5,
                    vertical: 4,
                  },
                  onItemClick: {
                    toggleDataSeries: true,
                  },
                  onItemHover: {
                    highlightDataSeries: true,
                  },
                },
                chart: {
                  zoom: {
                    enabled: true,
                  },
                  toolbar: {
                    show: true,
                  },
                  redrawOnParentResize: true,
                },
                colors: ['#E2A040', '#53A9DA', '#E7515A', '#009688'],
                dataLabels: {
                  enabled: false,
                },
                stroke: {
                  curve: 'smooth',
                  width: [2, 2, 2],
                },
                title: {
                  text: 'Daily Comulative Report',
                  align: 'left',
                },
                markers: {
                  size: 0,

                  hover: {
                    sizeOffset: 6,
                  },
                },
                xaxis: {
                  categories: reportStatistics.categories,
                },
                yaxis: {
                  labels: {
                    formatter: function (val) {
                      return val.toFixed(0);
                    },
                  },
                },
                grid: {
                  show: true,
                  strokeDashArray: 0.3,
                  borderColor: '#000', // you can either change hear to disable all grids
                  xaxis: {
                    lines: {
                      show: false, //or just here to disable only x axis grids
                    },
                  },
                  yaxis: {
                    lines: {
                      show: true, //or just here to disable only y axis
                    },
                  },
                },
              }"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StatisticsService from "@/helpers/statistics.service";
import { userService } from "@/helpers/authservice/user.service";
import { notificationMethods } from "@/state/helpers";
import PreferencesServices from "@/helpers/preferences.service";
import moment from "moment";
import _ from "lodash";

export default {
  components: {},
  data() {
    return {
      theme: localStorage.getItem("theme"),
      reportStatistics: {
        series: [
          {
            name: "Draft",
            data: [],
          },
          {
            name: "Pending",
            data: [],
          },
          {
            name: "Not Valid",
            data: [],
          },
          {
            name: "Validate",
            data: [],
          },
        ],
        categories: [],
      },
      loading: {
        reportstatistic: false,
      },
      start_range: "",
      end_range: "",
      dailyReportInterval: "7d",
      charttype: "bar",
    };
  },
  methods: {
    getDailyReports() {
      let ferr = 0;
      this.loading.reportstatistic = true;
      const params = {
        int: this.dailyReportInterval,
        start_range: this.formatDate(this.start_range),
        end_range: this.formatDate(this.end_range),
      };
      // console.log("params", params);
      StatisticsService.getDailyReport(params)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getDailyReports();
            this.$store.dispatch("notification/refreshtoken", "refresh");
            ferr = 1;
          } else {
            ferr = 2;
            this.reportStatistics.series[0].data = [];
            this.reportStatistics.series[1].data = [];
            this.reportStatistics.series[2].data = [];
            this.reportStatistics.series[3].data = [];
            this.reportStatistics.categories = [];

            const grouped = _.groupBy(
              response.data.data,
              (rep) => rep.date_format
            );

            _.map(_.values(grouped), (arr) => {
              let checkRes = {
                0: false,
                1: false,
                2: false,
                3: false,
              };
              arr.forEach((el) => {
                if (el.status_report == 0) {
                  this.reportStatistics.series[0].data.push(el.total_daily);
                  checkRes[0] = true;
                }
                if (el.status_report == 1) {
                  this.reportStatistics.series[1].data.push(el.total_daily);
                  checkRes[1] = true;
                }
                if (el.status_report == 2) {
                  this.reportStatistics.series[2].data.push(el.total_daily);
                  checkRes[2] = true;
                }
                if (el.status_report == 3) {
                  this.reportStatistics.series[3].data.push(el.total_daily);
                  checkRes[3] = true;
                }
              });

              for (let i = 0; i < 4; i++) {
                if (checkRes[i] == false) {
                  this.reportStatistics.series[i].data.push(0);
                }
              }

              this.reportStatistics.categories.push(arr[0].date_format);
            });
            this.loading.reportstatistic = false;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getDailyReports();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading.reportstatistic = false;
            }
          }
        });
    },
    changeType(type) {
      this.charttype = type;
    },
    formatDate(value) {
      return moment(value).format("YYYYMMDD");
    },
  },
  mounted() {
    this.getDailyReports();
  },
};
</script>
>
